module.exports = __webpack_public_path__ + "static/media/breakfast1-1.3729fcf9.jpg";